import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { budgetsService, BudgetCreate, BudgetUpdate } from '@/services/budgets';
import toast from 'react-hot-toast';

export function useBudgets() {
  return useQuery({
    queryKey: ['budgets'],
    queryFn: budgetsService.getBudgets,
  });
}

export function useCreateBudget() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: BudgetCreate) => budgetsService.createBudget(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['budgets'] });
      toast.success('Presupuesto guardado');
    },
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Error al guardar el presupuesto'),
  });
}

export function useUpdateBudget() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: BudgetUpdate }) => budgetsService.updateBudget(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['budgets'] });
      toast.success('Presupuesto actualizado');
    },
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Error al actualizar el presupuesto'),
  });
}

export function useDeleteBudget() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => budgetsService.deleteBudget(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['budgets'] });
      toast.success('Presupuesto eliminado');
    },
    onError: (e: any) => toast.error(e?.response?.data?.detail || 'Error al eliminar el presupuesto'),
  });
}
